module.exports = __webpack_public_path__ + "static/media/visuel02.980dfcc0.jpg";